import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const RequestOrderDetails = createAsyncThunk(
  "RequestOrderDetails",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/RequestOrderDetails",
        {
          OrderNo:data1,
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
        localStorage.clear();
        window.location.assign("/");
      }
    }
  }
);

const RequestOrderSlice = createSlice({
  name: "RequestOrder",
  initialState: {
    isLoading: "hide",
    isEmpty: "hide",
    isFilled: "",
    data: [],
    isError: "hide",
  },
 
  extraReducers: (builder) => {
    builder
      .addCase(RequestOrderDetails.fulfilled, (state, action) => {
        state.isLoading = "hide";
        state.isEmpty = "hide";
        state.isFilled = "";
        if (action.payload === "[NoDataFound]") {
          state.data = [];
          state.isEmpty = "";
          state.isFilled = "hide";
        } else {
          state.data = action.payload; 
        }
        state.isError = "hide";
      })
      .addCase(RequestOrderDetails.pending, (state, action) => {
        state.isLoading = "";
        state.isEmpty = "hide";
        state.isFilled = "";
        state.isError = "hide";
      })
      .addCase(RequestOrderDetails.rejected, (state, action) => {
        state.isError = "";
        state.isEmpty = "hide";
        state.isFilled = "";
        state.isLoading = "hide";
      });
  },
});
 
export default RequestOrderSlice.reducer;
